<template>
  <div
    v-if="showLogo"
    id="InicioLogo"
    class="tooltip-container"
  >
    <!-- Texto logo centrado -->
    <transition
      name="fade"
      @before-leave="beforeLeaveLogo"
      @leave="leaveLogo"
    >
      <div v-if="!transitioning" class="text-logo">
        <div class="initials">Johanna Duran</div>
        <div class="names">Mis XV </div>
      </div>
    </transition>

    <!-- Tooltip -->
    <span
      class="tooltip-text"
      :class="{ 'show-tooltip': showTooltip }"
    >{{ tooltipText }}</span>
  </div>
</template>

<script>
export default {
  name: 'InicioLogo',
  data() {
    return {
      tooltipText: '¡Pulsa aquí!',
      showTooltip: false,
      showLogo: true,
      tooltipTimeout: null,
      transitioning: false,
    };
  },
  mounted() {
    this.tooltipTimeout = setTimeout(() => {
      this.showTooltip = true;
    }, 4000);

    document.addEventListener('click', this.handleClickAnywhere);
  },
  beforeUnmount() {
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
    document.removeEventListener('click', this.handleClickAnywhere);
  },
  methods: {
    hideTooltip() {
      this.showTooltip = false;
      this.startTransition();
    },
    handleClickAnywhere() {
      this.hideTooltip();
    },
    startTransition() {
      this.transitioning = true;
      setTimeout(() => {
        this.showLogo = false;
      }, 1000);
    },
    beforeLeaveLogo(el) {
      el.style.transition = 'opacity 1s ease-in-out';
    },
    leaveLogo(el) {
      el.style.opacity = 0;
    }
  }
};
</script>

<style scoped>
#InicioLogo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fffefd;
  z-index: 20;
  margin: 0;
  border: none;
  overflow: hidden;
}

.text-logo {
  text-align: center;
  animation: scaleAnimation 1s ease-in-out infinite alternate both;
  cursor: pointer;
  z-index: 20;
}

.initials {
  font-family: 'Playfair Display', serif;
  font-size: 38px;
  letter-spacing: 0px;
  color: #6f0606;
}

.divider {
  margin: 0 16px;
}

.names {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  letter-spacing: 4px;
  color: #480505d4;
  margin-top: 10px;
}

.tooltip-text {
  visibility: hidden;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.10);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  top: calc(50% - 70px);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  z-index: 30;
}

.show-tooltip {
  visibility: visible;
  opacity: 1;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@keyframes scaleAnimation {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.2);
    opacity: 1;
  }
}
</style>